<template>
  <div class="bg-gray">
    <div class="box-content">
      <el-table :data="row.subject_list" ref="table" :show-header="false">
        <!--        <el-table-column type="index" label="序号" width="56" align="center"></el-table-column>-->
        <el-table-column prop="yundongyuan" label="用户名" min-width="140">
          <template slot-scope="scope">
            {{ '项目' + (scope.$index + 1) }}
            <div>运动员：<el-tag class="mr10" round size="small" v-for="(member,index) in scope.row.yundongyuan" :key="index" type="primary">
              {{ member.name }}</el-tag></div>
          </template>
        </el-table-column>
        <el-table-column prop="subject_name" label="用户名" min-width="140"></el-table-column>
        <el-table-column align="right">
          <template slot-scope="scope">
            <el-button
                size="medium"
                type="primary"
                v-if="scope.row.video.length==0"
                v-rblink="{name:'ISaiApplyFormUploadVideo',query:{ id: scope.row.id }}">上传视频</el-button>
            <el-button
                size="medium"
                v-else
                readonly
                v-rblink="{name:'ISaiApplyFormUploadVideo',query:{ id: scope.row.id }}"
            >视频已上传</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}


.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'StationApply',
  components: {
    PicUploader,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {
        danwei: {},
        subject_list: []
      },
      formData: {},
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.row.id = this.$route.query.id;
    this.fetch();

    window.rbMessage = function (data) {
      if (data == 'saiApplyVideoReload') {
        that.fetch();
      }
    }

  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/isai/videolist', {
        id: that.row.id
      }, (res) => {
        that.row = res.data;
      }, (res) => {
        Toast.fail(res.msg);
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyVideoList.vue?4ddcae1b